export default {
  namespaced: true,
  camera_proxy: {
    title: "camera proxy | cameras proxy",
    id: "camera proxy id",
    rtsp_available: "Ativar transmissão RTSP",
    last_connection: "última conexão",
    assigned: "atribuída",
    rec_mode: "modo de gravação",
    rec_hours: "dias de gravação",
    days: "Dias",
    limit: {
      "3_days": "3 dias",
      "7_days": "7 dias",
      "14_days": "14 dias",
      "30_days": "30 dias",
      "60_days": "60 dias",
      "90_days": "90 dias",
      "180_days": "180 dias",
      "1_year": "1 ano",
      "2_years": "2 anos",
      custom: "Personalizado",
    },
    recording_enable: "habilitar gravação",
    on_demand: "habilitar sob demanda",
    vbr_quality: "Qualidade VBR",
    frame_rate: "Taxa de quadros",
    resolution: "Resolução",
    store:{
      space_200_gb: "200 GB",
      space_500_gb: "500 GB",
      space_1_tb: "1 TB",
    },
    profile: "perfil",
    encoding: "codificação",
    resolution: "resolução",
    frame_rate: "taxa de quadros",
    bitrate: "taxa de bits",
    vbr: "vbr",
    quality: "qualidade",
    gov: "gov",
    send_to_seproban: "Enviar para seproban"
  },
};
